<div *ngIf="item.button_type!='text'">
    <div style="text-align:right;">
        <p-button variant="text" severity="info" (click)="openView(item.view, info)" [title]="(item.translation_key||item.title || 'open ' + item.view)| translation|translationFromString | transformText :item?.text_transform">
            <i class="fas fa-cog"></i>
        </p-button>
    </div>
</div>
<div *ngIf="item.button_type=='text'">
    <p-button variant="text" severity="info" (click)="openView(item.view, info)">{{item.translation_key||item.title| translation|translationFromString | transformText :item?.text_transform}}</p-button>
</div>